import type { paths } from "@/api-schema";
import { encodeLogoRequest } from "@/common/helpers/encode-file";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const BRAND_UPDATE_RESOURCE = "brand" as const;
export const BRAND_UPDATE_API_PATH = `/v1/${BRAND_UPDATE_RESOURCE}/{uuid}` as const;

export type BrandUpdateBody =
  paths[typeof BRAND_UPDATE_API_PATH]["patch"]["requestBody"]["content"]["application/json"];
export type BrandUpdateInput = Omit<BrandUpdateBody, "logo"> & {
  uuid: string;
  logo?: File | null;
};
export type BrandUpdateResponse =
  paths[typeof BRAND_UPDATE_API_PATH]["patch"]["responses"][200]["content"]["application/json"];

export const useBrandUpdateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<BrandUpdateResponse, Error, BrandUpdateInput>({
    mutationFn: async (data: BrandUpdateInput) => {
      const { uuid, ...rest } = data;
      const response = await alphartisApiAxios.patch<BrandUpdateResponse>(
        `/v1/${BRAND_UPDATE_RESOURCE}/${uuid}`,
        await encodeLogoRequest(rest),
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [BRAND_UPDATE_RESOURCE],
      });
    },
  });
};
